'use client';

import cn from '@sindresorhus/class-names';
import classNames from '@sindresorhus/class-names';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import {useCallback, useEffect, useState} from 'react';

import BlackSearch from '@web-landing/assets/images/search/black_search_icon.svg';
import SearchImage from '@web-landing/assets/images/search/search.svg';

import {searchInputTestIds} from '@web-landing/constants/test-ids/mainLandingTestIds';

import {useIsMobile} from '@web-landing/hooks/useIsMobile';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import {ym_log} from '../analytics';
import styles from './Search.module.scss';

const SearchInput = dynamic(async () =>
  import(
    '@web-landing/components/SearchBlock/components/SearchInput/SearchInput'
  ).then(({SearchInput}) => SearchInput),
);

type Props = {
  className?: string;
  requestUrl?: string;
  isNewHeaderVersion?: boolean;
};

export const Search = ({
  className,
  requestUrl,
  isNewHeaderVersion = false,
}: Props) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const isMobile = useIsMobile();
  const isTmr = typeof window !== 'undefined' && window._tmr;
  const [metricWasSend, setMetricSend] = useState(false);
  //Костыль, потому что в хедер появляется раньше, чем window.tmr и сам Window

  const handleShowSearch = useCallback(() => {
    setIsSearchVisible(true);
    document.body.classList.add(styles.hiddenScroll);
    logTmrEvent(EVENTS.searchClick);

    ym_log.headerSearchButtonClick();
  }, [setIsSearchVisible]);

  const handleHideSearch = useCallback(() => {
    setIsSearchVisible(false);

    document.body.classList.remove(styles.hiddenScroll);
  }, [setIsSearchVisible]);

  useEffect(() => {
    if (isTmr && !metricWasSend) {
      setMetricSend(true);

      logTmrEvent(EVENTS.searchView, {
        location: 'top',
      });
    }
  }, [isTmr, metricWasSend]);
  return (
    <>
      <div
        className={cn(styles.container, className, {
          [styles.newVersion]: isNewHeaderVersion,
        })}
        onClick={handleShowSearch}
        data-testid={searchInputTestIds.searchButton}
      >
        <Image
          src={isNewHeaderVersion ? BlackSearch : SearchImage}
          alt="SearchImage"
        />
        <span className={styles.findTitle}>Поиск</span>
      </div>

      {isSearchVisible && !isMobile && (
        <div
          className={classNames(styles.modal, {
            [styles.newVersionModal]: isNewHeaderVersion,
          })}
          onClick={handleHideSearch}
          data-testid={searchInputTestIds.searchBlock}
        >
          <SearchInput
            requestUrl={requestUrl}
            targetLocation="top"
            autoFocus
            withoutLayout
          />
        </div>
      )}

      {isSearchVisible && isMobile && (
        <div className={classNames(styles.mobileSearch)}>
          <SearchInput
            requestUrl={requestUrl}
            isMobile={isMobile}
            handleHideSearch={handleHideSearch}
            targetLocation="top"
          />
        </div>
      )}
    </>
  );
};
